import { render, staticRenderFns } from "./UserOrders.vue?vue&type=template&id=aee33dbc"
import script from "./UserOrders.vue?vue&type=script&lang=js"
export * from "./UserOrders.vue?vue&type=script&lang=js"
import style0 from "./UserOrders.vue?vue&type=style&index=0&id=aee33dbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports